import '../../utils/index2.mjs';
import Badge from './src/badge4.mjs';
export { badgeProps } from './src/badge3.mjs';
import { withInstall } from '../../utils/vue/install2.mjs';

const ElBadge = withInstall(Badge);

export { ElBadge, ElBadge as default };
//# sourceMappingURL=index2.mjs.map
